export const siteConfig = {
  langs: {
    de: {
      label: 'Deutsch',
      key: 'de'
    },
    en: {
      label: 'English',
      key: 'en'
    }
  },
  defaultLangKey: () => {
    return this.langs.de.key
  }
}
